import Token from './token'
import Form from './form'

export default {
  svg: 'message_square',
  label: 'Send Message',
  type: 'sms',
  action: 'message',
  config: {},
  form: Form,
  token: Token
}
